export default "__VITE_ASSET__f98RJc4J__"